import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { Button } from '@material-ui/core'

import { Container, ContentHeader, DriveTour, Page } from 'components'
import AiInventoryForm from './components/AiInventoryForm'

import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import { routes } from 'Routes'
import * as service from 'service'
import helpers from 'helpers'
import { buildGeneralInfoPayload } from './components/AiInventoryForm/formMappers'

const AiInventoryNew = () => {
  const history = useHistory()
  const snackbar = useSnackbar()
  const [openTour, setOpenTour] = useState(false)

  const handleStepSubmit = async (step, data) => {
    try {
      if (step === 0) {
        const response = await service.dponet.aiInventory.create(
          buildGeneralInfoPayload(data),
        )
        const newId = response?.data?.aiInventoryItem?.id
        history.push(
          reverse(routes.aiInventory.edit, { aiInventoryId: newId }),
          { initialStep: 1 },
        )
      }
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao salvar. Tente novamente.',
        variant: 'error',
      })
      throw error
    }
  }

  return (
    <Page title="Nova IA">
      <Container maxWidth={false}>
        <ContentHeader title="Nova IA">
          <Button
            id={constants.aiInventory.AI_INVENTORY_FORM_DRIVER_STEP_1}
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={() => setOpenTour(true)}
          >
            Tutorial
          </Button>
        </ContentHeader>
        <AiInventoryForm
          mode="new"
          onStepSubmit={handleStepSubmit}
          onBack={() => history.push(routes.aiInventory.all)}
        />
      </Container>
      <DriveTour
        stepsMatrix={constants.aiInventory.AI_INVENTORY_FORM_DRIVER_STEPS}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default AiInventoryNew
